import React, { useMemo, useCallback } from 'react';
import useGameStore from '../stores/gameStore';

const RightSidebar = ({ isOpen, onClose, isGamePage }) => {
  const { 
    messages,
    messageInput,
    setMessageInput,
    onSendMessage
  } = useGameStore();
  
  // Ensure messages is always an array
  const safeMessages = useMemo(() => Array.isArray(messages) ? messages : [], [messages]);

  // Handle send message with proper error handling
  const handleSendMessage = useCallback((e) => {
    e.preventDefault();
    if (messageInput.trim() && onSendMessage) {
      onSendMessage(e);
    } else if (!onSendMessage) {
      console.warn('⚠️ onSendMessage not available in game store');
    }
  }, [messageInput, onSendMessage]);

  if (!isOpen || !isGamePage) return null;

  return (
    <div className="mobile-right-sidebar fixed top-0 right-0 h-full w-80 bg-gray-900/95 backdrop-blur-lg border-l border-gray-700/50 shadow-xl z-40 lg:hidden">
      <div className="flex flex-col h-full">
        {/* Right Sidebar Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-700/50">
          <h2 className="text-lg font-bold text-white">Game Chat</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white transition-colors"
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Chat Content */}
        <div className="flex-1 flex flex-col p-4">
          {/* Chat Messages */}
          <div className="flex-1 overflow-y-auto bg-gray-800/50 rounded-lg p-3 space-y-2 mb-4">
            {safeMessages.map((message, index) => (
              <div key={index} className="text-sm text-gray-300">
                • {message}
              </div>
            ))}
          </div>
          
          {/* Message Input */}
          <form onSubmit={handleSendMessage} className="space-y-2">
            <div className="flex gap-2">
              <input
                type="text"
                value={messageInput || ''}
                onChange={(e) => setMessageInput(e.target.value)}
                placeholder="Type a message..."
                className="flex-1 bg-gray-800/50 border border-gray-600 rounded-lg px-3 py-2 text-white text-sm placeholder-gray-400 focus:outline-none focus:border-emerald-500"
                maxLength={200}
              />
              <button
                type="submit"
                disabled={!messageInput?.trim() || !onSendMessage}
                className="bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 disabled:opacity-50 disabled:cursor-not-allowed text-white px-4 py-2 rounded-lg transition-all duration-200 flex items-center gap-1"
              >
                <span className="text-sm">Send</span>
              </button>
            </div>
            <div className="text-xs text-gray-400 text-right">
              {(messageInput || '').length}/200 characters
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RightSidebar;
